import React, { useEffect, useState } from 'react';
import { FiMail } from 'react-icons/fi';
import { SUPPORT_EMAIL } from '../../config/emailjs';
import { configService } from '../../services/configService';
import { useThemeClasses } from '../../hooks/useThemeClasses';

/**
 * Aviso tras enviar correos transaccionales (registro, activación, reset).
 */
export default function TransactionalEmailHint({ className = '' }) {
  const tc = useThemeClasses();
  const [sender, setSender] = useState(SUPPORT_EMAIL);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const cfg = await configService.getPublicConfig();
        const fromApi = cfg?.contact?.transactionalSenderEmail || cfg?.contact?.supportEmail;
        if (!cancelled && fromApi) setSender(fromApi);
      } catch {
        /* fallback SUPPORT_EMAIL */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      className={`rounded-xl border px-3 py-2.5 text-left text-[11px] leading-snug flex gap-2 ${
        tc.modoOscuro ? 'border-amber-900/50 bg-amber-950/25 text-amber-100/90' : 'border-amber-200 bg-amber-50/90 text-amber-950'
      } ${className}`.trim()}
      role="note"
    >
      <FiMail className="w-4 h-4 shrink-0 mt-0.5 opacity-80" aria-hidden />
      <p>
        Si no ves el correo en unos minutos, revisá <strong>Spam</strong> o <strong>Promociones</strong> y tocá{' '}
        <strong>No es spam</strong>. Los enviamos desde <strong>{sender}</strong> (podés agregarlo a contactos).
      </p>
    </div>
  );
}
